<template>
  <button v-bind="$attrs" @click="$emit('click')"><span></span><span></span><span></span></button>
</template>

<script>
export default {
  name: "button-dotted"
}
</script>

<style scoped>
  button {border: none; background: none; display: flex; background: transparent; padding: 4px;}
  button > span {background: #6C757D; width: 4px; height: 4px; border-radius: 50%;}
  button > span:not(:last-child) { margin-right: 2px;}

</style>
